import '../scss/style.scss'

import $ from 'jquery';
window.$ = $;
import 'bootstrap-sass';
//import 'lodash';
import 'iframe-resizer/js/iframeResizer.contentWindow.min';
import './helpers';